/**
 * Shared animation helpers for the homepage card grids.
 *
 * The prototype's `_archive/home.html` (line ~1503) animates each card into
 * place with a 70ms-per-card cascade. We reproduce that with the
 * `animate-card-in` Tailwind utility (defined in `tailwind.config.ts`)
 * plus a per-card `animation-delay` set inline based on the card's index.
 */

/** Tailwind classes that initialize a card to its pre-entrance state. */
export const CARD_ENTRANCE = 'opacity-0 animate-card-in';

/**
 * Inline `animation-delay` for the staggered entrance cascade. Pair with
 * `CARD_ENTRANCE` on the same element.
 *
 * @param idx        Card position in the grid (0-based).
 * @param msPerStep  Delay between cards. Defaults to 70ms — matches the
 *                   prototype's stagger constant.
 */
export function staggerStyle(idx: number, msPerStep = 70): React.CSSProperties {
  return { animationDelay: `${idx * msPerStep}ms` };
}
